import { render, staticRenderFns } from "./roomCard.vue?vue&type=template&id=1945a2b4"
import script from "./roomCard.vue?vue&type=script&lang=js"
export * from "./roomCard.vue?vue&type=script&lang=js"
import style0 from "./roomCard.vue?vue&type=style&index=0&id=1945a2b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports